
              import "_sentry-debug-id-injection-stub";
              import * as OriginalModule from "./console/index.jsx";
              export default OriginalModule.default;
              export * from "./console/index.jsx";